import React, { Fragment } from "react"
import DefaultTitle from "shared/components/DefaultTitle"
import ManagerSkeleton from "../ManagerOnlineInterfaceSkeleton"
import NoScheduleSkeleton from "../NoScheduleOnlineInterfaceSkeleton"
import HistorySkeleton from "../HistoryOnlineInterfaceSkeleton"

const OnlineInterfaceSkeleton = () => {
  return (
    <Fragment>
      <DefaultTitle>Interface Online</DefaultTitle>
      <ManagerSkeleton />
      <NoScheduleSkeleton />
      <HistorySkeleton />
    </Fragment>
  )
}

export default OnlineInterfaceSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/OnlineInterfaceSkeleton/index.js